import { apiClient } from '@common/http/query-client';

export function setupProfileInterceptor() {
    apiClient.interceptors.request.use(config => {
        // CRÍTICO: Deve usar a mesma chave que o active-profile-context.tsx salva!
        // O contexto salva em 'bootk_active_profile_id'
        const profileId = localStorage.getItem('bootk_active_profile_id');
        if (profileId) {
            config.headers['X-Profile-Id'] = profileId;
        }
        return config;
    });
}

